export interface IWhiteLabelDetails {
  id: string;
  hash: string;
  created: string;
  name?: string;
  domain?: string;
  regulationsConfigDto?: {
    productCampaign?: Record<string, string>;
    displayCampaign?: Record<string, string>;
  },
  frontendConfigDto?: {
    faviconImageId?: string;
    logoImageId?: string;
    browserTabTitle?: string;
    logoutRedirectUrl?: string;
    translations?: string;
  };
}

export namespace WhiteLabel {
  export interface IDetailsInternal extends IWhiteLabelDetails {
    shopId: string;
  }

  export const createEmptyDetailsInternal = (): IDetailsInternal => ({
    id: '',
    hash: '',
    created: '',
    shopId: '',
  });
}
